import { TooltipProps as InfoTooltipProps } from "antd";

import InfoTooltip from "./InfoTooltip";

export type { InfoTooltipProps };
export default InfoTooltip;
